import { render } from "./LoginInterface.vue?vue&type=template&id=40f6372e&ts=true"
import script from "./LoginInterface.vue?vue&type=script&lang=ts"
export * from "./LoginInterface.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__